import * as yup from 'yup';

export const DEFAULT_MANUAL_COMMENT = 'начисление бонусов за офлайн заказ';

export const manualBonusFormSchema = yup.object({
  sellerId: yup
    .mixed<string | number>()
    .nullable()
    .default(null)
    .test('sellerId-required', 'Выберите продавца', (val) => val != null && val !== ''),
  userId: yup
    .mixed<string | number>()
    .nullable()
    .default(null)
    .test('userId-required', 'Выберите пользователя', (val) => val != null && val !== ''),
  type: yup
    .string()
    .oneOf(['accrue', 'deduct'], 'Выберите операцию')
    .required('Выберите операцию'),
  amountType: yup
    .string()
    .oneOf(['arbitrary', 'from_order'])
    .nullable()
    .when('type', {
      is: 'accrue',
      then: (schema) => schema.required('Выберите тип начисления'),
      otherwise: (schema) => schema.nullable().optional(),
    }),
  amount: yup
    .number()
    .transform((v, orig) => (orig === '' || orig === undefined ? undefined : v))
    .nullable()
    .optional()
    .test('amount-required', 'Укажите количество бонусов', function (value) {
      const { type, amountType } = this.parent;
      if (type === 'deduct' || (type === 'accrue' && amountType === 'arbitrary')) {
        return value != null && value >= 1;
      }
      return true;
    }),
  orderAmount: yup
    .number()
    .transform((v, orig) => (orig === '' || orig === undefined ? undefined : v))
    .nullable()
    .optional()
    .test('orderAmount-required', 'Укажите сумму заказа', function (value) {
      const { type, amountType } = this.parent;
      if (type === 'accrue' && amountType === 'from_order') {
        return value != null && value >= 0.01;
      }
      return true;
    }),
  expiresDays: yup
    .number()
    .transform((v, orig) => (orig === '' || orig === undefined ? undefined : v))
    .nullable()
    .optional()
    .min(0, 'Срок не может быть отрицательным'),
  description: yup.string().required('Укажите комментарий').default(DEFAULT_MANUAL_COMMENT),
});

export type ManualBonusFormValues = yup.InferType<typeof manualBonusFormSchema>;
